import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable no-access page shown when a feature is disabled by Visibility Settings.
 */
function NoAccess({
  title = "No access",
  message = "You do not have permission to view this page.",
  showBack = true,
}) {
  return (
    <div className="min-h-screen bg-green-cloud flex items-center justify-center px-4 py-10">
      <div className="card-brand-elevated max-w-lg w-full p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-sunrise-red/10 text-sunrise-red flex items-center justify-center mx-auto mb-5">
          <i className="fas fa-lock text-2xl" />
        </div>

        <h1 className="text-2xl font-bold text-grey-dusk mb-2">{title}</h1>

        <p className="text-slate-cloud leading-relaxed">{message}</p>

        {showBack && (
          <Link
            to="/"
            className="mt-6 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-sunrise-red text-white font-semibold hover:bg-sunrise-600 transition-colors"
          >
            <i className="fas fa-arrow-left text-sm" />
            Back to dashboard
          </Link>
        )}
      </div>
    </div>
  );
}

export default NoAccess;